function toJS(entity, defaultValue = null) {
  return entity && entity.toJS ? entity.toJS() : defaultValue;
}

// eslint-disable-next-line import/prefer-default-export
export { toJS };
